import { BMT_COMPANION_FLAG, BMT_SCAN_TYPE } from '@/constants/bmt';

/** `?from=bmt` on /scanner: the BMT page's own "Scan to check in" button. */
export const BMT_SCANNER_ENTRY = 'bmt';

const COURSE_EXEMPT_ACTIONS = ['redeem', 'unlock', 'leader-unlock'];

/**
 * Which feature flag lets a member onto /scanner for this route query, or null
 * when no flag is needed.
 *
 * Course unlock links are scanned with the phone's camera and must work with
 * the `scanner` flag off (see the /scanner route for the history). BMT check-in
 * is the same shape of problem: trainees are given `bmt-companion`, not
 * `scanner`, and check-in is only ever a QR scan, so a BMT scan, or the BMT
 * page opening the camera, answers to the BMT flag instead.
 */
export function scannerFlagFor(query = {}) {
  if (query.type === 'course' && COURSE_EXEMPT_ACTIONS.includes(query.action)) return null;
  if (query.type === BMT_SCAN_TYPE || query.from === BMT_SCANNER_ENTRY) return BMT_COMPANION_FLAG;
  return 'scanner';
}
